import { useImagesFastCache } from "@design-lab/entities/artwork/model/useImagesFastCache";
import { ArrowLeft } from "lucide-react";
import type { GeneratedImage } from "./AiImageGallery";
import { ImagePlaceholder } from "./ImagePlaceholder";

export type SingleImageRefinementViewProps = {
  image: GeneratedImage;
  onBack: () => void;
  onSelect?: () => void;
  isSelected?: boolean;
  isRefining?: boolean;
  headerText?: string;
};

export function SingleImageRefinementView({
  image,
  onBack,
  onSelect,
  isSelected = false,
  isRefining = false,
  headerText = "Back to all images"
}: SingleImageRefinementViewProps) {
  // Use cached image for instant display
  const [cachedImage] = useImagesFastCache([image.imageSrc]);
  const displaySrc = cachedImage?.base64 || image.imageSrc;

  return (
    <div className="flex h-full flex-col">
      <button
        onClick={onBack}
        className="mb-4 flex cursor-pointer items-center gap-2 text-base font-medium text-gray-600 hover:text-gray-900 lg:mb-4"
        data-testid="back-to-gallery-button"
      >
        <ArrowLeft className="size-4" />
        <span className="lg:hidden">{headerText}</span>
        <span className="hidden lg:inline">Back to all images</span>
      </button>

      {/* Image Container */}
      <div className="flex flex-1 items-center justify-center">
        <div className="aspect-square h-full max-w-full flex-none">
          <ImagePlaceholder
            imageSrc={displaySrc}
            imageAlt={image.imageAlt}
            isSelected={isSelected}
            isLoading={isRefining}
            crossOrigin="anonymous"
            isRefineMode={true}
            {...(onSelect && { onSelect })}
          />
        </div>
      </div>
    </div>
  );
}
